import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { Review, ReviewsState } from "../../types/types";

export const fetchReviews = createAsyncThunk<Review[], void>(
  "reviews/fetchReviews",
  async () => {
    const API_URL = process.env.REACT_APP_URL_BACKEND;
    const response = await fetch(`${API_URL}/api/v1/reviews/`);

    if (!response.ok) {
      throw new Error("Ошибка при загрузке отзывов");
    }

    return await response.json();
  }
);

const initialState: ReviewsState = {
  reviews: [],
  loading: false,
  error: null,
};

const reviewsSlice = createSlice({
  name: "reviews",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviews.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchReviews.fulfilled,
        (state, action: PayloadAction<Review[]>) => {
          state.loading = false;
          state.reviews = action.payload;
        }
      )
      .addCase(fetchReviews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Что-то пошло не так";
      });
  },
});

export const selectReviews = (state: { reviews: ReviewsState }) =>
  state.reviews.reviews;

export const selectLoading = (state: { reviews: ReviewsState }) =>
  state.reviews.loading;

export const selectError = (state: { reviews: ReviewsState }) =>
  state.reviews.error;

export default reviewsSlice.reducer;
